export default require('../otherChains/hyperliquidTestnet').default.rpcUrls.default.http[0]